// console.log("ft-fitment script run ");

(async function () {
  const script =
    document.currentScript ||
    document.querySelector('script[src*="ft-hero-dd.js"]');

  const root = document.getElementById("ft-fitment-root");
  if (!script || !root) return;

  /* ---------------- required static DOM refs ---------------- */

  const els = {
    titleUrl: root.querySelector("#ftfit-title"),
    titlePage: root.querySelector("#ftfit-page-title"),
    bc: root.querySelector("#ftfit-bc"),
    panel: root.querySelector("#ftfit-panel"),
    head: root.querySelector("#ftfit-panel-head"),
    headTitle: root.querySelector("#ftfit-panel-title"),
    back: root.querySelector("#vs-back-global"),

    body: root.querySelector("#ftfit-panel-body"),
    dynamic: root.querySelector("#ftfit-dynamic"),

    atcWrap: root.querySelector("[data-atc-scope]"),
    atcBtn: root.querySelector("[data-atc-btn]"),
    anotherBtn: root.querySelector("[data-another-btn]"),
    atcError: root.querySelector("[data-atc-error]"),
  };

  if (!els.body) {
    console.warn("[ftfit] #ftfit-panel-body not found. Ensure static shell HTML exists.");
    return;
  }
  if (!els.dynamic) {
    console.warn("[ftfit] #ftfit-dynamic not found. Please add <div id='ftfit-dynamic'>...</div> into panel body.");
    return;
  }

  // data attrs (liquid ile geliyor)
  const ftMarketUrl = script.dataset.ftMarket || "/products/ft-market.json";
  const prioritizedMakesUrl = script.dataset.prioritizedMakes || "/products/prioritizedMakes.json";
  const prioritizedModelsUrl = script.dataset.prioritizedModels || "/products/prioritizedModels.json";

  // FN Tuned product JS
  const fnTunedProductJsUrl = "/products/fn-tuned.js";

  /* ---------------- helpers ---------------- */

  const STORAGE_NAMESPACE = "ftFitment";

  const norm = (s) => (s || "").toString().trim().toLowerCase();
  const esc = (s) =>
    (s || "").toString().replace(/[&<>"']/g, (c) => {
      const map = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
      return map[c] || c;
    });


  const normalizeSocket = (s) =>
    (s || "").toString().replace(/-.*$/, "").trim();

  const getStorageKey = (key, url) => `${STORAGE_NAMESPACE}:${key}:${url}`;

  const clearOldVersions = (key, currentUrl) => {
    try {
      const prefix = `${STORAGE_NAMESPACE}:${key}:`;

      for (let i = localStorage.length - 1; i >= 0; i--) {
        const storageKey = localStorage.key(i);
        if (!storageKey) continue;
        if (!storageKey.startsWith(prefix)) continue;
        if (storageKey === getStorageKey(key, currentUrl)) continue;

        localStorage.removeItem(storageKey);
      }
    } catch {}
  };

  const getFromStorage = (key, url) => {
    try {
      const raw = localStorage.getItem(getStorageKey(key, url));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  const saveToStorage = (key, url, data) => {
    try {
      clearOldVersions(key, url);
      localStorage.setItem(getStorageKey(key, url), JSON.stringify(data));
    } catch {}
  };

  const fetchText = async (url) => {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed (${res.status}): ${url}`);
    return res.text();
  };

  const fetchJson = async (url) => {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed (${res.status}): ${url}`);
    return res.json();
  };

  const getData = async (key, url) => {
    const cached = getFromStorage(key, url);
    if (cached && Array.isArray(cached)) return cached;

    const data = await fetchJson(url);
    if (Array.isArray(data)) saveToStorage(key, url, data);
    return data;
  };

  const uniq = (arr) => {
    const seen = new Set();
    return arr.filter((x) => {
      const k = norm(x);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  };

  // Shopify product js parse (JSON or JS containing "variants": [...])
  const parseProductVariantsFromText = (text) => {
    try {
      const j = JSON.parse(text);
      if (j && Array.isArray(j.variants)) return j.variants;
    } catch {}

    const m = text.match(/"variants"\s*:\s*(\[[\s\S]*?\])/);
    if (m && m[1]) {
      try {
        const arr = JSON.parse(m[1]);
        if (Array.isArray(arr)) return arr;
      } catch {}
    }

    const objMatch = text.match(/\{[\s\S]*\}/);
    if (objMatch) {
      try {
        const j = JSON.parse(objMatch[0]);
        if (j && Array.isArray(j.variants)) return j.variants;
      } catch {}
    }

    return null;
  };

  const updateUrlWithMakeModel = (make, model) => {
    try {
      const u = new URL(window.location.href);
      if (make) u.searchParams.set("make", make);
      if (model) u.searchParams.set("model", model);
      if (!make) u.searchParams.delete("make");
      if (!model) u.searchParams.delete("model");
      history.replaceState({}, "", u.toString());
    } catch (e) {
      console.warn("URL update failed:", e);
    }
  };

  /* ---------------- ATC show/hide helpers ---------------- */

  const syncAtcDataset = (variantId) => {
    if (!els.atcWrap) return;

    const vid = variantId ? Number(variantId) : 0;

    const props = {
      Make: state.make || "",
      Model: state.model || "",
      Body: state.selectedFitment?.body || "",
      "Engine Volume": state.selectedFitment?.engineVolume || "",
      // Socket: state.selectedFitment?.socket || "",
    };

    const atcButtons = els.atcWrap.querySelectorAll('[data-atc="true"]');
    atcButtons.forEach((b) => {
      b.dataset.variantId = vid ? String(vid) : "";
      b.dataset.properties = JSON.stringify(props);
    });
  };

  const hideAtc = () => {
    if (els.atcWrap) els.atcWrap.hidden = true;

    if (els.atcBtn) {
      els.atcBtn.dataset.variantId = "";
      els.atcBtn.dataset.properties = "";
    }

    if (els.atcError) els.atcError.hidden = true;
  };

  const showAtc = (variantId) => {
    if (!els.atcWrap) return;

    els.atcWrap.hidden = false;

    const fitmentCount = getFitmentVariants(state.make, state.model).length;
    if (els.anotherBtn) els.anotherBtn.hidden = fitmentCount <= 1;

    syncAtcDataset(variantId);

    if (els.atcError) els.atcError.hidden = !!variantId;
  };

  /* ---------------- scroll helpers ---------------- */

  const scrollPanelBodyTop = () => {
    const body = els.body;
    if (!body) return;
    try {
      body.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      body.scrollTop = 0;
    }
  };

  const scrollRootTop = (offset = 0) => {
    const top = root.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, top - offset), behavior: "smooth" });
  };

  /* ---------------- hard hide helpers ---------------- */

  const setPanelHeadHiddenHard = (hidden) => {
    if (!els.head) return;
    els.head.hidden = !!hidden;
    els.head.style.display = hidden ? "none" : "";
  };

  const setPageTitleHidden = (hidden) => {
    if (!els.titlePage) return;
    els.titlePage.hidden = !!hidden;
    els.titlePage.style.display = hidden ? "none" : "";
  };

  /* ---------------- layout mode (url vs picker) ---------------- */

  const setLayoutMode = (mode) => {
    root.classList.toggle("is-url", mode === "url");

    if (els.titleUrl) els.titleUrl.style.display = mode === "url" ? "" : "none";
    if (els.titlePage) els.titlePage.style.display = mode === "picker" ? "" : "none";

    if (mode === "url") {
      setPanelHeadHiddenHard(true);
      setPageTitleHidden(true);
    } else {
      setPanelHeadHiddenHard(false);
      setPageTitleHidden(false);
    }
  };

  /* ---------------- loading/error (dynamic only) ---------------- */

  const showDynamicLoading = (msg = "Loading...") => {
    els.dynamic.innerHTML = `<div class="ftfit__loading">${esc(msg)}</div>`;
  };

  const showDynamicError = (msg = "Something went wrong.") => {
    els.dynamic.innerHTML = `<div class="ftfit__error">${esc(msg)}</div>`;
  };

  /* ---------------- URL state ---------------- */

  const qs = new URLSearchParams(window.location.search);
  const urlMake = qs.get("make");
  const urlModel = qs.get("model");
  const hasMakeModelInUrl = !!(urlMake && urlModel);

  /* ---------------- state ---------------- */

  const state = {
    make: urlMake || "",
    model: urlModel || "",
    selectedFitment: null, // { body, engineVolume, socket, shopifyVariantId }
    ftMarket: null,
    prioritizedMakes: null,
    prioritizedModels: null,
    fnVariants: null,
  };

  /* ---------------- data lookup ---------------- */

  const findMakeObj = (make) =>
    (state.ftMarket || []).find((x) => norm(x.make) === norm(make));

  const findModelObj = (make, model) => {
    const mk = findMakeObj(make);
    if (!mk || !Array.isArray(mk.models)) return null;
    return mk.models.find((m) => norm(m.model) === norm(model));
  };

  const getFitmentVariants = (make, model) => {
    const mo = findModelObj(make, model);
    const vars = mo?.variants;
    return Array.isArray(vars) ? vars : [];
  };

  const isPrioritizedModel = (make, model) => {
    const list = state.prioritizedModels || [];
    const a = norm(`${make} ${model}`);
    const b = norm(model);
    return list.some((p) => {
      const pn = norm(p);
      return pn === a || pn === b || pn.includes(b);
    });
  };

  /* ---------------- FN tuned variant-id match ---------------- */

  const ensureFnTunedVariantsLoaded = async () => {
    if (state.fnVariants && Array.isArray(state.fnVariants)) return state.fnVariants;

    const text = await fetchText(fnTunedProductJsUrl);
    const variants = parseProductVariantsFromText(text);
    if (!variants || !Array.isArray(variants)) throw new Error("fn-tuned variants parse failed");
    state.fnVariants = variants;

    return variants;
  };

  const matchSocketToShopifyVariantId = async (socket) => {
    const variants = await ensureFnTunedVariantsLoaded();
    const target = norm(normalizeSocket(socket)); // FT07-JP -> ft07

    const exact = variants.find((v) => norm(v.title) === target);
    if (exact) {
      // console.log(`[ftfit] Socket "${socket}" -> Shopify variant "${exact.title}" (id: ${exact.id})`);
      return exact.id;
    }

    const loose = variants.find((v) => norm(normalizeSocket(v.title)) === target);
    console.log(
      loose
        ? `[ftfit] Socket "${socket}" -> Shopify variant "${loose.title}" (id: ${loose.id}) [normalized match]`
        : `[ftfit] Socket "${socket}" -> NO Shopify variant found`
    );
    return loose ? loose.id : null;
  };

  /* ---------------- breadcrumb ---------------- */

  const buildBreadcrumbParts = () => {
    const parts = [];
    if (state.make) parts.push(state.make);
    if (state.model) parts.push(state.model);
    if (state.selectedFitment) {
      if (state.selectedFitment.body) parts.push(state.selectedFitment.body);
      if (state.selectedFitment.engineVolume) parts.push(state.selectedFitment.engineVolume);
      if (state.selectedFitment.socket) parts.push(normalizeSocket(state.selectedFitment.socket));
    }
    return parts;
  };

  const renderBreadcrumbHtml = () => {
    const parts = buildBreadcrumbParts();
    if (!parts.length) return "";
    const items = parts
      .map((p) => `<span class="ftfit__crumb">${esc(p)}</span>`)
      .join(`<span class="ftfit__crumb-sep">›</span>`);
    return `<div class="ftfit__breadcrumbs">${items}</div>`;
  };

  const syncBreadcrumb = () => {
    if (els.bc) els.bc.innerHTML = renderBreadcrumbHtml();
  };

  /* =========================================================
     SHARED: variant buttons HTML (body / engine / socket)
  ========================================================= */

  const renderVariantButtonsHtml = (fitments) => `
    <div class="ftfit__variants">
      ${fitments
        .map((f) => {
          const bodyTxt = f.body || "Body";
          const engineTxt = f["engine-volume"] || "Engine";
          const socketTxt = normalizeSocket(f.socket); // FT07-JP -> FT07
          return `
            <button
              type="button"
              class="ftfit__variant-btn"
              data-body="${esc(bodyTxt)}"
              data-engine="${esc(engineTxt)}"
              data-socket="${esc(socketTxt)}"
            >
              <div style="font-weight:900;">${esc(bodyTxt)}</div>
              <div style="margin-top:6px;color:rgba(255,255,255,0.70);font-weight:800;line-height:1.3;">
                ${esc(engineTxt)}
              </div>
              <div style="margin-top:8px;color:rgba(255,255,255,0.55);font-weight:800;letter-spacing:0.08em;">
                ${esc(socketTxt)}
              </div>
            </button>
          `;
        })
        .join("")}
    </div>
  `;

  /* =========================================================
     RENDER: PICKER (NO URL) STEPS
  ========================================================= */

  const renderMakes = () => {
    setLayoutMode("picker");
    hideAtc();

    state.make = "";
    state.model = "";
    state.selectedFitment = null;
    syncBreadcrumb();

    if (els.headTitle) els.headTitle.textContent = "Select Make";
    if (els.back) {
      els.back.style.visibility = "hidden";
      els.back.onclick = null;
    }

    const allMakes = (state.ftMarket || []).map((x) => x.make).filter(Boolean);
    const prioritizedSet = new Set((state.prioritizedMakes || []).map(norm));

    const best = uniq(allMakes.filter((m) => prioritizedSet.has(norm(m))));
    const other = uniq(allMakes.filter((m) => !prioritizedSet.has(norm(m)))).sort((a, b) =>
      a.localeCompare(b)
    );

    const renderGroup = (groupTitle, list) => {
      if (!list.length) return "";
      return `
        <div class="ftfit__group-title" style="margin-top:8px;">${esc(groupTitle)}</div>
        <div class="ftfit__list">
          ${list
            .map((m) => `<button type="button" class="ftfit__item" data-make="${esc(m)}">${esc(m)}</button>`)
            .join("")}
        </div>
      `;
    };

    els.dynamic.innerHTML = renderGroup("Best sellers", best) + renderGroup("Other makes", other);

    els.dynamic.querySelectorAll("[data-make]").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.make = btn.dataset.make || "";
        state.model = "";
        state.selectedFitment = null;
        syncBreadcrumb();
        renderModels(state.make);
        scrollPanelBodyTop();
      });
    });

    updateUrlWithMakeModel("", "");
    scrollPanelBodyTop();
  };

  const renderModels = (make) => {
    setLayoutMode("picker");
    hideAtc();

    state.model = "";
    state.selectedFitment = null;
    syncBreadcrumb();

    if (els.headTitle) els.headTitle.textContent = "Select Model";
    if (els.back) {
      els.back.style.visibility = "visible";
      els.back.onclick = () => {
        renderMakes();
        scrollPanelBodyTop();
      };
    }

    const mk = findMakeObj(make);
    const models = (mk?.models || []).map((x) => x.model).filter(Boolean);

    const best = [];
    const other = [];
    models.forEach((m) => (isPrioritizedModel(make, m) ? best : other).push(m));

    const bestUniq = uniq(best);
    const otherUniq = uniq(other).sort((a, b) => a.localeCompare(b));

    const renderGroup = (groupTitle, list) => {
      if (!list.length) return "";
      return `
        <div class="ftfit__group-title" style="margin-top:8px;">${esc(groupTitle)}</div>
        <div class="ftfit__list">
          ${list
            .map((m) => `<button type="button" class="ftfit__item" data-model="${esc(m)}">${esc(m)}</button>`)
            .join("")}
        </div>
      `;
    };

    els.dynamic.innerHTML = renderGroup("Best sellers", bestUniq) + renderGroup("Other models", otherUniq);

    els.dynamic.querySelectorAll("[data-model]").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.model = btn.dataset.model || "";
        state.selectedFitment = null;

        updateUrlWithMakeModel(state.make, state.model);
        syncBreadcrumb();

        renderFitmentVariantsList();
        scrollPanelBodyTop();
      });
    });

    scrollPanelBodyTop();
  };

  const renderFitmentVariantsList = () => {
    setLayoutMode("picker");
    syncBreadcrumb();

    if (els.headTitle) els.headTitle.textContent = "Select Body / Engine";
    if (els.back) {
      els.back.style.visibility = "visible";
      els.back.onclick = () => {
        renderModels(state.make);
        scrollPanelBodyTop();
      };
    }

    const fitments = getFitmentVariants(state.make, state.model);
    const single = fitments.length === 1;

    if (single && !state.selectedFitment) {
      hideAtc();

      const f = fitments[0];
      state.selectedFitment = {
        body: f.body || "",
        engineVolume: f["engine-volume"] || "",
        socket: normalizeSocket(f.socket),
        shopifyVariantId: null,
      };

      syncBreadcrumb();
      setPanelHeadHiddenHard(true);
      setPageTitleHidden(true);

      els.dynamic.innerHTML = `<div class="ftfit__loading">Matching socket...</div>`;
      scrollPanelBodyTop();

      matchSocketToShopifyVariantId(state.selectedFitment.socket)
        .then((id) => {
          state.selectedFitment.shopifyVariantId = id;
          renderFitmentVariantsList();
        })
        .catch((e) => {
          console.error(e);
          state.selectedFitment.shopifyVariantId = null;
          renderFitmentVariantsList();
        });

      return;
    }

    if (state.selectedFitment) {
      setPanelHeadHiddenHard(true);
      setPageTitleHidden(true);
      syncBreadcrumb();

      els.dynamic.innerHTML = "";
      showAtc(state.selectedFitment.shopifyVariantId);

      scrollPanelBodyTop();
      return;
    }

    hideAtc();
    setPanelHeadHiddenHard(false);
    setPageTitleHidden(false);

    if (!fitments.length) {
      els.dynamic.innerHTML = `<div class="ftfit__empty">No fitment found for this vehicle.</div>`;
      scrollPanelBodyTop();
      return;
    }

    els.dynamic.innerHTML = renderVariantButtonsHtml(fitments);

    els.dynamic.querySelectorAll(".ftfit__variant-btn").forEach((btn) => {
      btn.addEventListener("click", async () => {
        setPanelHeadHiddenHard(true);

        const socket = normalizeSocket(btn.dataset.socket);

        state.selectedFitment = {
          body: btn.dataset.body || "",
          engineVolume: btn.dataset.engine || "",
          socket,
          shopifyVariantId: null,
        };

        syncBreadcrumb();

        els.dynamic.innerHTML = `<div class="ftfit__loading">Matching socket...</div>`;
        scrollRootTop(90);
        scrollPanelBodyTop();

        try {
          const id = await matchSocketToShopifyVariantId(socket);
          state.selectedFitment.shopifyVariantId = id;
        } catch (e) {
          console.error(e);
          state.selectedFitment.shopifyVariantId = null;
        }

        renderFitmentVariantsList();
        scrollPanelBodyTop();
      });
    });

    scrollPanelBodyTop();
  };

  /* =========================================================
     RENDER: URL MODE (make/model in URL)
  ========================================================= */

  const renderUrlFitmentList = () => {
    setLayoutMode("url");
    syncBreadcrumb();

    const fitments = getFitmentVariants(state.make, state.model);
    const single = fitments.length === 1;

    if (els.titleUrl) els.titleUrl.textContent = `FN TUNED for ${state.make} ${state.model}`;

    if (single && !state.selectedFitment) {
      hideAtc();

      const f = fitments[0];
      state.selectedFitment = {
        body: f.body || "",
        engineVolume: f["engine-volume"] || "",
        socket: normalizeSocket(f.socket),
        shopifyVariantId: null,
      };

      syncBreadcrumb();
      els.dynamic.innerHTML = `<div class="ftfit__loading">Matching socket...</div>`;
      scrollPanelBodyTop();

      matchSocketToShopifyVariantId(state.selectedFitment.socket)
        .then((id) => {
          state.selectedFitment.shopifyVariantId = id;
          renderUrlFitmentList();
        })
        .catch((e) => {
          console.error(e);
          state.selectedFitment.shopifyVariantId = null;
          renderUrlFitmentList();
        });

      return;
    }

    if (state.selectedFitment) {
      els.dynamic.innerHTML = "";
      showAtc(state.selectedFitment.shopifyVariantId);

      scrollPanelBodyTop();
      return;
    }

    hideAtc();

    if (!fitments.length) {
      els.dynamic.innerHTML = `<div id="atc-error">Fitment data could not be loaded for this vehicle.</div>`;
      scrollPanelBodyTop();
      return;
    }

    els.dynamic.innerHTML = renderVariantButtonsHtml(fitments);

    els.dynamic.querySelectorAll(".ftfit__variant-btn").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const socket = normalizeSocket(btn.dataset.socket);
        state.selectedFitment = {
          body: btn.dataset.body || "",
          engineVolume: btn.dataset.engine || "",
          socket,
          shopifyVariantId: null,
        };

        syncBreadcrumb();
        els.dynamic.innerHTML = `<div class="ftfit__loading">Matching socket...</div>`;
        scrollRootTop();
        scrollPanelBodyTop();

        try {
          const id = await matchSocketToShopifyVariantId(socket);
          state.selectedFitment.shopifyVariantId = id;
        } catch (e) {
          console.error(e);
          state.selectedFitment.shopifyVariantId = null;
        }

        renderUrlFitmentList();
        scrollPanelBodyTop();
      });
    });

    scrollPanelBodyTop();
  };

  /* ---------------- init data ---------------- */

  const ensureFtData = async () => {
    const cachedMarket = getFromStorage("ftMarket", ftMarketUrl);
    const cachedPMakes = getFromStorage("prioritizedMakes", prioritizedMakesUrl);
    const cachedPModels = getFromStorage("prioritizedModels", prioritizedModelsUrl);

    if (Array.isArray(cachedMarket) && Array.isArray(cachedPMakes) && Array.isArray(cachedPModels)) {
      state.ftMarket = cachedMarket;
      state.prioritizedMakes = cachedPMakes;
      state.prioritizedModels = cachedPModels;
      return;
    }

    const [m, pmk, pmd] = await Promise.all([
      getData("ftMarket", ftMarketUrl),
      getData("prioritizedMakes", prioritizedMakesUrl),
      getData("prioritizedModels", prioritizedModelsUrl),
    ]);

    state.ftMarket = m;
    state.prioritizedMakes = pmk;
    state.prioritizedModels = pmd;
  };


  /* ---------------- bind "Select another body" once ---------------- */

  if (els.anotherBtn && els.anotherBtn.dataset.bound !== "1") {
    els.anotherBtn.dataset.bound = "1";
    els.anotherBtn.addEventListener("click", () => {
      state.selectedFitment = null;

      setPanelHeadHiddenHard(false);
      setPageTitleHidden(false);

      hideAtc();

      if (root.classList.contains("is-url")) {
        renderUrlFitmentList();
        scrollRootTop();
      } else {
        renderFitmentVariantsList();
      }
      scrollPanelBodyTop();
    });
  }

  /* ---------------- init ---------------- */

  try {
    hideAtc();
    showDynamicLoading("Loading...");

    await ensureFtData();

    if (hasMakeModelInUrl) {
      state.make = urlMake || "";
      state.model = urlModel || "";
      state.selectedFitment = null;

      if (!findModelObj(state.make, state.model)) {
        setLayoutMode("url");
        if (els.titleUrl) els.titleUrl.textContent = `FN TUNED`;
        syncBreadcrumb();
        showDynamicError("Vehicle not found in ft-market.");
        return;
      }

      renderUrlFitmentList();
      scrollPanelBodyTop();
    } else {
      renderMakes();
      scrollPanelBodyTop();
    }
  } catch (e) {
    console.error(e);
    showDynamicError("Initialization failed.");
  }
})();